import { render, staticRenderFns } from "./ProductHistoryMobileLine.vue?vue&type=template&id=6677e86a&scoped=true"
import script from "./ProductHistoryMobileLine.vue?vue&type=script&lang=js"
export * from "./ProductHistoryMobileLine.vue?vue&type=script&lang=js"
import style0 from "./ProductHistoryMobileLine.vue?vue&type=style&index=0&id=6677e86a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677e86a",
  null
  
)

export default component.exports